/**
 * TanStack Query hooks for `campaign-archive`. Thin wrappers over ./api —
 * invalidations hang off the shared `['campaign-archive']` key so a restore
 * or purge immediately refreshes the table.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	campaignArchiveQueryKeys,
	listArchived,
	purgeCampaign,
	restoreCampaign,
	type ListArchivedResponse,
	type UnarchiveResponse,
} from "./api";

export function useCampaignArchiveList(): UseQueryResult<
	ListArchivedResponse,
	Error
> {
	return useQuery({
		queryKey: campaignArchiveQueryKeys.list(),
		queryFn: listArchived,
	});
}

export function useCampaignArchiveRestore(): UseMutationResult<
	UnarchiveResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: restoreCampaign,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignArchiveQueryKeys.all });
		},
	});
}

export function useCampaignArchivePurge(): UseMutationResult<
	UnarchiveResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: purgeCampaign,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignArchiveQueryKeys.all });
		},
	});
}
